import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesInsights } from "../../constants";
import { InventoryInsightsListItem } from "../../insights.types";

export const requestInventoryInsights = async (
  params: GetListRequestParams
): Promise<GetListResponse<InventoryInsightsListItem>> => {
  return await instance.get(ApiRoutesInsights.InventoryInsights, {
    params
  });
};
